import { all } from 'redux-saga/effects';

import { utilsSagas } from './utils/sagas';
import { attendanceSagas } from './attendance/sagas';
import { benefitsSagas } from './benefits/sagas';
import { bugReportsSagas } from './bugReports/sagas';
import { dbdsSagas } from './dbds/sagas';
import { fleetSagas } from './fleet/sagas';
import { dialogsSagas } from './dialogs/sagas';
import { linesSagas } from './lines/sagas';
import { profilesSagas } from './profiles/sagas';
import { lotsSagas } from './lots/sagas';
import { operatorsSagas } from './operators/sagas';
import { transportCardsSagas } from './transportCards/sagas';
import { transportOperatorsSagas } from './transportOperators/sagas';
import { supervisorsGroupsSagas } from './supervisorsGroups/sagas';
import { usersSagas } from './users/sagas';
import { snackbarsSagas } from './snackbars/sagas';
import { schemasSagas } from './schemas/sagas';
import { sectionsSagas } from './sections/sagas';
import { stopsSagas } from './stops/sagas';
import { employeesSagas } from './employees/sagas';
import { companiesSagas } from './companies/sagas';
import { collaboratorsSagas } from './collaborators/sagas';
import { ordersSagas } from './orders/sagas';
import { ordersSchoolSagas } from './ordersSchool/sagas';
import { schoolSettingsSagas } from './schoolSettings/sagas';
import { collaboratorsGroupsSagas } from './collaboratorsGroups/sagas';
import { denylistSagas } from './denylist/sagas';
import { userProfileSagas } from './userProfile/sagas';
import { reportsSagas } from './reports/sagas';
import { faresSagas } from './fares/sagas';
import { schoolsSagas } from './schools/sagas';
import { serviceDiscoverySagas } from './serviceDiscovery/sagas';
import { studentsSagas } from './students/sagas';
import { itinerariesSagas } from './itineraries/sagas';
import { garageSagas } from './garage/sagas';
import { sellingPointsSagas } from './sellingPoints/sagas';
import { sellingTerminalsSagas } from './sellingTerminals/sagas';
import { cardReceivablesSagas } from './cardReceivables/sagas';
import { tripsSagas } from './trips/sagas';
import { employeesSalesSagas } from './employeesSales/sagas';
import { terminalsSagas } from './terminals/sagas';
import { terminalBlocksSagas } from './terminalBlocks/sagas';
import { userIpsSagas } from './userIps/sagas';
import { printModelSagas } from './printModel/sagas';
import { facialSagas } from './facial/sagas';
import { walletSagas } from './wallet/sagas';
import { walletExpirationSettingsSagas } from './walletExpirationSettings/sagas';
import { devicesSagas } from './devices/sagas';
import { transportCardsPlaceSagas } from './transportCardsPlace/sagas';
import { lineLotSagas } from './lineLot/sagas';
import { tollSagas } from './tolls/sagas';
import { integrationFenceSagas } from './integrationFence/sagas';
import { schedulesMatrixSagas } from './schedulesMatrix/sagas';
import { audioSagas } from './audio/sagas';
import { linesMatrixIntegrationSagas } from './linesMatrixIntegration/sagas';
import { companyUsersSagas } from './companyUsers/sagas';
import { companyReportSagas } from './company/sagas';
import { appUserMergeSagas } from './appUserMerge/sagas';
import { notificationsSagas } from './notifications/sagas';
import { segmentationsSagas } from './segmentations/sagas';
import { anomaliesSagas } from './anomalies/sagas';
import { connectivityChipsSagas } from './connectivityChips/sagas';
import { balanceSagas } from './balance/sagas';
import { turnstilesSalesSagas } from './turnstiles/sagas';
import { productSagas } from './product/sagas';
import { fareBonusSagas } from './fareBonus/sagas';
import { fareTaxSagas } from './fareTax/sagas';
import { synopticSagas } from './synoptic/sagas';
import { taxSagas } from './tax/sagas';
import { scheduleSagas } from './schedule/sagas';
import { publicStoreSagas } from './publicStore/sagas';
import { plantasSagas } from './plantas/sagas';
import { bpeSagas } from './bpe/sagas';

export default function* rootSaga() {
  yield all([
    ...attendanceSagas,
    ...benefitsSagas,
    ...bugReportsSagas,
    ...dbdsSagas,
    ...fleetSagas,
    ...dialogsSagas,
    ...linesSagas,
    ...itinerariesSagas,
    ...profilesSagas,
    ...lotsSagas,
    ...operatorsSagas,
    ...transportOperatorsSagas,
    ...transportCardsSagas,
    ...supervisorsGroupsSagas,
    ...usersSagas,
    ...snackbarsSagas,
    ...schemasSagas,
    ...sectionsSagas,
    ...stopsSagas,
    ...employeesSagas,
    ...companiesSagas,
    ...collaboratorsSagas,
    ...ordersSagas,
    ...ordersSchoolSagas,
    ...schoolSettingsSagas,
    ...collaboratorsGroupsSagas,
    ...denylistSagas,
    ...userProfileSagas,
    ...reportsSagas,
    ...faresSagas,
    ...utilsSagas,
    ...schoolsSagas,
    ...serviceDiscoverySagas,
    ...studentsSagas,
    ...garageSagas,
    ...sellingPointsSagas,
    ...sellingTerminalsSagas,
    ...cardReceivablesSagas,
    ...tripsSagas,
    ...printModelSagas,
    ...employeesSalesSagas,
    ...terminalsSagas,
    ...terminalBlocksSagas,
    ...userIpsSagas,
    ...facialSagas,
    ...walletSagas,
    ...walletExpirationSettingsSagas,
    ...devicesSagas,
    ...transportCardsPlaceSagas,
    ...lineLotSagas,
    ...tollSagas,
    ...integrationFenceSagas,
    ...schedulesMatrixSagas,
    ...audioSagas,
    ...linesMatrixIntegrationSagas,
    ...companyUsersSagas,
    ...companyReportSagas,
    ...synopticSagas,
    ...appUserMergeSagas,
    ...notificationsSagas,
    ...segmentationsSagas,
    ...anomaliesSagas,
    ...bpeSagas,
    ...connectivityChipsSagas,
    ...balanceSagas,
    ...turnstilesSalesSagas,
    ...productSagas,
    ...fareBonusSagas,
    ...fareTaxSagas,
    ...synopticSagas,
    ...taxSagas,
    ...scheduleSagas,
    ...publicStoreSagas,
    ...plantasSagas,
  ]);
}
